import React from "react";

import styles from "./DoneEqueuesList.style";
import {Div, List} from "@vkontakte/vkui";
import SimpleEqueue from "../SimpleEqueue";
import {connect} from "react-redux";
import {selectEqueue} from "../../../redux/actions/selectedEqueueAction";
import {setActivePanel} from "../../../redux/actions/panelsActions";
import {panels} from "../../../variables";

const DoneEqueuesList = ({items, selectEqueue, goToSelectedEqueuePanel}) => {

    const onEqueueClick = (id) => {
        selectEqueue(id);
        goToSelectedEqueuePanel()
    }
    return (
        <Div style={{
            padding: "0"
        }}>
            <List style={styles.doneEqueuesList}>
                {
                    items ? items.map(equeue => {
                        return (
                            <SimpleEqueue key={equeue.id} equeue={equeue} done onClick = {() => onEqueueClick(equeue.id)}/>
                        )
                    }) : null
                }
            </List>
        </Div>
    )
}

const mapDispatchToProps = (dispatch) => {
    return {
        selectEqueue: (id) => dispatch(selectEqueue(id)),
        goToSelectedEqueuePanel: () => dispatch(setActivePanel(panels.selectedEqueue))
    }
}

export default connect(null, mapDispatchToProps)(DoneEqueuesList);